<template>
  <div id="app" class="compliance-doc site hfeed">
    <HeadNav selectedLanguage="en" :page="page" />
    <div id="content" class="site-content compliance-doc__wrap">
      <main class="compliance-doc__main">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ComplianceLayout',
  components: {
    HeadNav,
  },
  props: {
    // 传给 HeadNav，用于路由/埋点等识别
    page: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
/* 合规页阅读排版 */
.compliance-doc__main {
  width: var(--read-content-width, 80%);
  max-width: none;
  margin: 36px auto 56px;
  padding: 0 0 40px;
  line-height: var(--read-lh, 1.8);
  color: var(--read-text, #374151);
  font-family: var(--read-font);
  font-size: var(--read-size, 1.0625rem);
  box-sizing: border-box;
}

.compliance-doc__main h1 {
  font-size: var(--read-h1, 2.1rem);
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin: 0 0 1.1rem;
  color: var(--read-text-strong, #1f2937);
}

.compliance-doc__main h2 {
  font-size: var(--read-h2, 1.55rem);
  font-weight: 700;
  line-height: 1.35;
  margin: 2rem 0 0.85rem;
  color: var(--read-text-strong, #1f2937);
}

.compliance-doc__main p {
  margin: 0 0 1.1rem;
  line-height: inherit;
}

.compliance-doc__main ul {
  margin: 0 0 1.1rem;
  padding-left: 1.5rem;
}

.compliance-doc__main li {
  margin-bottom: 0.5rem;
  line-height: inherit;
}

.compliance-doc__main a {
  color: var(--read-link, #06c755);
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--read-link-hover, #05a949);
  }
}

@media (max-width: 768px) {
  .compliance-doc__main {
    width: 100%;
    margin-top: 22px;
    padding: 0 16px 32px;
  }

  .compliance-doc__main h1 {
    font-size: 1.65rem;
  }

  .compliance-doc__main h2 {
    font-size: 1.3rem;
  }
}
</style>
